import clsx from "clsx"

import Table from "@/ui/components/Table"
import { spacedNum } from "@/components/common/CommonHelper"

import type { ICompanyBank } from "@/types/company/IFullCompanyDto"
import type { FC } from "react"

import style from "../../style.module.scss"

type Props = {
  item: ICompanyBank
  index: number
}

export const BalanceBanksItem: FC<Props> = ({ item, index }) => {
  return (
    <Table.Item
      className={clsx(style.banksTableRow, style.banksTableRowItem, { [style.banksTableRowItemEven]: index % 2 === 1 })}
    >
      <div>{item.name}</div>
      <div>{item.swift}</div>
      <div>{item.id}</div>
      <div className={style.banksTableRowAccount}>{item.accountNumber}</div>
      <div>{item.currency}</div>
      <div>{item.balance ? spacedNum(item.balance / 100) : 0}</div>
    </Table.Item>
  )
}
